<template>
    <v-content class="pa-12">
        <v-layout style="background-color: #FAF5F2;">
            <v-flex>
                <!-- Nevigater -->
                <v-layout mb-12>
                    <v-flex shrink d-flex justify-start align-center class="nevigater-link" @click="$router.push('/post-approve')">
                        <span>Post Approve</span>
                    </v-flex>
                    <v-flex shrink d-flex justify-start align-center>
                        <v-icon color="#3E7662">arrow_right</v-icon>
                    </v-flex>
                    <v-flex shrink d-flex justify-start align-center class="nevigater-link"  @click="viewData">
                        <span>ดูข้อมูล</span>
                    </v-flex>
                    <v-flex shrink d-flex justify-start align-center>
                        <v-icon color="#3E7662">arrow_right</v-icon>
                    </v-flex>
                    <v-flex shrink d-flex justify-start align-center style="color: #3E7662;font-weight: bold;font-size: 24px;">
                        <span>รายงานแก้ไขเพิ่มเติมโครงร่างการวิจัย</span>
                    </v-flex>
                </v-layout>


                <v-layout>
                    <v-flex>
                        <v-layout mt-3 style="background-color: #3E7662;">
                            <v-flex my-8 ml-8 style="text-align: left;font-size: 28px;color: white" @click="setData">
                                <div style="font-weight: bold">แบบรายงานการแก้ไขเพิ่มเติมโครงร่างการวิจัย</div>
                                <div style="font-size: 18px;">Amendment Form</div>
                            </v-flex>
                            <v-flex ml-8 pt-8 pr-8 style="text-align: right;font-weight: bold;font-size: 13px;color: white">
                                <span>RF 12_2563</span>
                            </v-flex>
                        </v-layout>

                        <!-- blog 1 -->
                        <v-card class="mb-12 px-12">
                            <v-layout py-12 pr-12 mr-12>
                                <v-flex>
                                    <!-- row 1 -->
                                    <v-layout pt-8>
                                        <v-flex xs2 mr-4 pt-2 style="text-align: right;font-weight: bold;">
                                            <span>รหัสโครงร่างการวิจัย</span>
                                        </v-flex>
                                        <v-flex xs4>
                                            <textfield-form
                                                    :model="form.researchCode"
                                                    @update-data="updateData('researchCode', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>
                                    <!-- row 2 -->
                                    <v-layout>
                                        <v-flex xs2 mr-4 pt-2 style="text-align: right;font-weight: bold;">
                                            <span>ชื่อผู้วิจัยหลัก</span>
                                        </v-flex>
                                        <v-flex xs4>
                                            <textfield-form
                                                    :model="form.firstName"
                                                    @update-data="updateData('firstName', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                        <v-flex xs2 pr-4 pt-2 style="text-align: right;font-weight: bold;">
                                            <span>นามสกุล</span>
                                        </v-flex>
                                        <v-flex xs4>
                                            <textfield-form
                                                    :model="form.lastName"
                                                    @update-data="updateData('lastName', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>
                                    <!-- row 3 -->
                                    <v-layout pb-6>
                                        <v-flex xs2 mr-4 pt-2 style="text-align: right;font-weight: bold;">
                                            <span>ชื่อโครงการวิจัย</span>
                                        </v-flex>
                                        <v-flex xs10>
                                            <textarea-form
                                                    :model="form.researchName"
                                                    @update-data="updateData('researchName', $event)"
                                            ></textarea-form>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-card>

                        <!-- blog 2 -->
                        <v-layout mt-3 style="background-color: #3E7662;">
                            <v-flex pl-6 my-5 ml-8 style="text-align: left;font-size: 28px;color: white" @click="setData">
                                <div style="font-weight: bold">SUMMARY OF PROTOCOL AMENDMENT FOR RISK/BENEFIT ASSESSMENT</div>
                                <div style="font-size: 18px;">สรุปการปรับการดำเนินการในโครงร่างการวิจัยสำหรับการประเมินประโยชน์และความเสี่ยง</div>
                            </v-flex>
                        </v-layout>
                        <v-layout pt-12 pb-8 mb-12 style="background-color: white;padding-left: 60px;padding-right: 70px;">
                            <v-flex>
                                <!-- Group 1 -->
                                <v-layout>
                                    <v-flex style="text-align: left;font-weight: bold;">
                                        <span>1. การปรับเกณฑ์การคัดเข้า/คัดออก</span>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex pl-3 style="text-align: left;">
                                        <v-radio-group v-model="form.hasScreening" row>
                                            <v-radio color="#3E7662" style="padding-right: 100px" label="ใช่" value="0"></v-radio>
                                            <v-radio @click.native="clearRedio('hasScreening')" color="#3E7662" label="ไม่ใช่" value="1"></v-radio>
                                        </v-radio-group>
                                    </v-flex>
                                </v-layout>
                                <v-layout mb-6>
                                    <v-flex pl-3 style="text-align: left;">
                                        <textarea-form
                                                :disabled="form.hasScreening === '1'"
                                                :background-color="form.hasScreening === '1' ? '#F9F9F9' : '#FBF6F3'"
                                                :model="form.screening"
                                                placeholder="(อธิบายโดยสรุปและระบุเหตุผล)"
                                                @update-data="updateData('screening', $event)"
                                        ></textarea-form>
                                    </v-flex>
                                </v-layout>
                                <!-- Group 2 -->
                                <v-layout>
                                    <v-flex style="text-align: left;font-weight: bold;">
                                        <span>2. การปรับวิธีการหรือขนาดยา</span>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex pl-3 style="text-align: left;">
                                        <v-radio-group row v-model="form.hasAdjustMethod">
                                            <v-radio color="#3E7662" style="padding-right: 100px" label="ใช่" value="0"></v-radio>
                                            <v-radio @click.native="clearRedio('hasAdjustMethod')" color="#3E7662" label="ไม่ใช่" value="1"></v-radio>
                                        </v-radio-group>
                                    </v-flex>
                                </v-layout>
                                <v-layout mb-6>
                                    <v-flex pl-3 style="text-align: left;">
                                        <textarea-form
                                                :disabled="form.hasAdjustMethod === '1'"
                                                :background-color="form.hasAdjustMethod === '1' ? '#F9F9F9' : '#FBF6F3'"
                                                :model="form.adjustMethod"
                                                placeholder="(อธิบายโดยสรุปและระบุเหตุผล)"
                                                @update-data="updateData('adjustMethod', $event)"
                                        ></textarea-form>
                                    </v-flex>
                                </v-layout>
                                <!-- Group 3 -->
                                <v-layout>
                                    <v-flex style="text-align: left;font-weight: bold;">
                                        <span>3. เพิ่มเติมหัตถการในการวิจัย</span>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex pl-3 style="text-align: left;">
                                        <v-radio-group row v-model="form.hasAddOperate">
                                            <v-radio  color="#3E7662" style="padding-right: 100px" label="ใช่" value="0"></v-radio>
                                            <v-radio  @click.native="clearRedio('redio')" color="#3E7662" label="ไม่ใช่" value="1"></v-radio>
                                        </v-radio-group>
                                    </v-flex>
                                </v-layout>
                                <v-layout mb-6>
                                    <v-flex pl-3 style="text-align: left;">
                                        <textarea-form
                                                :disabled="form.hasAddOperate === '1'"
                                                :background-color="form.hasAddOperate === '1' ? '#F9F9F9' : '#FBF6F3'"
                                                :model="form.addOperate"
                                                placeholder="(อธิบายโดยสรุปและระบุเหตุผล)"
                                                @update-data="updateData('addOperate', $event)"
                                        ></textarea-form>
                                    </v-flex>
                                </v-layout>
                                <!-- Group 4 -->
                                <v-layout>
                                    <v-flex style="text-align: left;font-weight: bold;">
                                        <span>4. ขยายระยะเวลาการให้ยาวิจัย</span>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex pl-3 style="text-align: left;">
                                        <v-radio-group row v-model="form.hasExpandTime">
                                            <v-radio color="#3E7662" style="padding-right: 100px" label="ใช่" value="0"></v-radio>
                                            <v-radio  @click.native="clearRedio('hasExpandTime')" color="#3E7662" label="ไม่ใช่" value="1"></v-radio>
                                        </v-radio-group>
                                    </v-flex>
                                </v-layout>
                                <v-layout mb-6>
                                    <v-flex pl-3 style="text-align: left;">
                                        <textarea-form
                                                :disabled="form.hasExpandTime === '1'"
                                                :background-color="form.hasExpandTime === '1' ? '#F9F9F9' : '#FBF6F3'"
                                                :model="form.expandTime"
                                                placeholder="(อธิบายโดยสรุปและระบุเหตุผล)"
                                                @update-data="updateData('expandTime', $event)"
                                        ></textarea-form>
                                    </v-flex>
                                </v-layout>
                                <!-- Group 5 -->
                                <v-layout>
                                    <v-flex style="text-align: left;font-weight: bold;">
                                        <span>5. การปรับการดำเนินการวิจัยอื่นๆที่มีผลเพิ่มตามความเสี่ยงต่ออาสาสมัคร</span>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex pl-3 style="text-align: left;">
                                        <v-radio-group row v-model="form.hasAdjustOtherMethod">
                                            <v-radio color="#3E7662" style="padding-right: 100px" label="ใช่" value="0"></v-radio>
                                            <v-radio @click.native="clearRedio('hasAdjustOtherMethod')" color="#3E7662" label="ไม่ใช่" value="1"></v-radio>
                                        </v-radio-group>
                                    </v-flex>
                                </v-layout>
                                <v-layout mb-6>
                                    <v-flex pl-3 style="text-align: left;">
                                        <textarea-form
                                                :disabled="form.hasAdjustOtherMethod === '1'"
                                                :background-color="form.hasAdjustOtherMethod === '1' ? '#F9F9F9' : '#FBF6F3'"
                                                :model="form.adjustOtherMethod"
                                                placeholder="(อธิบายโดยสรุปและระบุเหตุผล)"
                                                @update-data="updateData('adjustOtherMethod', $event)"
                                        ></textarea-form>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>

                        <!-- Blog 3 -->
                        <v-layout pt-12 pb-8 mb-12 style="background-color: white;padding-left: 60px;padding-right: 70px;">
                            <v-flex>
                                <v-layout mb-12>
                                    <v-flex style="font-weight: bold" d-flex justify-start>
                                        <span>CHECK ALL PROTOCOL AMENDMENTS THAT APPLY :</span>
                                    </v-flex>
                                </v-layout>
                                <!-- Group 1 -->
                                <v-layout px-12>
                                    <v-flex xs6 :class="!form.hasInformationSheet ? '' : 'color-label-checkbox'" style="font-weight: bold;font-size: 18px" d-flex justify-start>
                                        <v-checkbox
                                                v-model="form.hasInformationSheet"
                                                color="#3E7662"
                                                label="Information sheet / Consent form"
                                                @change="clearCheckbox('hasInformationSheet')"
                                        ></v-checkbox>
                                    </v-flex>
                                    <v-flex xs6 d-flex justify-start>
                                        <v-layout pt-3>
                                            <v-flex xs6>
                                                <textfield-form-append
                                                        :disabled="!form.hasInformationSheet"
                                                        :model="form.informationSheetVersion"
                                                        css="color: #3E7662;font-weight: bold"
                                                        label="Version"
                                                        @update-data="updateData('informationSheetVersion', $event)"
                                                ></textfield-form-append>
                                            </v-flex>
                                            <v-flex xs6>
                                                <DateInputFormAppend
                                                        :disabled="!form.hasInformationSheet"
                                                        :model="informationSheetDate"
                                                        style="color: #3E7662;"
                                                        label="Date"
                                                        @update-data="updateDate('informationSheetDate', $event)"
                                                ></DateInputFormAppend>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex>
                                        <span>ไฟล์</span>
                                    </v-flex>
                                    <v-flex>
                                        <a :href="form.fileInformationSheetPath">
                                            <span>{{form.fileInformationSheet}}</span>
                                        </a>
                                    </v-flex>
                                </v-layout>
                                <v-layout px-12 pb-12>
                                    <v-flex style="text-align: left;color: #544A44;">
                                        <span>(Provide copy of original consent form, a description of the revisions and highlighted revised consent form)</span>
                                    </v-flex>
                                </v-layout>

                                <!-- Group 2 -->
                                <v-layout px-12 mt-8>
                                    <v-flex xs6 :class="!form.hasProtocolModify ? '' : 'color-label-checkbox'" style="font-weight: bold;font-size: 18px" d-flex justify-start>
                                        <v-checkbox
                                                v-model="form.hasProtocolModify"
                                                color="#3E7662"
                                                label="Protocol Modification or Amendment"
                                                @change="clearCheckbox('hasProtocolModify')"
                                        ></v-checkbox>
                                    </v-flex>
                                    <v-flex xs6 d-flex justify-start>
                                        <v-layout pt-3>
                                            <v-flex xs6>
                                                <textfield-form-append
                                                        :disabled="!form.hasProtocolModify"
                                                        :model="form.protocolModifyVersion"
                                                        css="color: #3E7662;font-weight: bold"
                                                        label="Version"
                                                        @update-data="updateData('protocolModifyVersion', $event)"
                                                ></textfield-form-append>
                                            </v-flex>
                                            <v-flex xs6>
                                                <DateInputFormAppend
                                                        :disabled="!form.hasProtocolModify"
                                                        :model="protocolModifyDate"
                                                        style="color: #3E7662;"
                                                        label="Date"
                                                        @update-data="updateDate('protocolModifyDate', $event)"
                                                ></DateInputFormAppend>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-layout px-12>
                                    <v-flex style="text-align: left;color: #544A44;">
                                        <span>
                                            (Attach a description of the modification, amendment, and addendum,
                                            all supporting documents, and a highlighted (tracked changed) revised consent form, if required.)
                                        </span>
                                    </v-flex>
                                </v-layout>
                                <!-- Group 3 -->
                                <v-layout mt-12 style="padding-left: 150px">
                                    <v-flex>
                                        <!-- row 1 -->
                                        <v-layout>
                                            <v-flex :class="!form.inclusion ? '' : 'color-label-checkbox'">
                                                <v-checkbox
                                                        :disabled="!form.hasProtocolModify"
                                                        v-model="form.inclusion"
                                                        hide-details
                                                        color="#3E7662"
                                                        label="Inclusion / Exclusion Criteria Change"
                                                ></v-checkbox>
                                            </v-flex>
                                        </v-layout>
                                        <!-- row 2 -->
                                        <v-layout>
                                            <v-flex :class="!form.procedureChange ? '' : 'color-label-checkbox'">
                                                <v-checkbox
                                                        :disabled="!form.hasProtocolModify"
                                                        v-model="form.procedureChange"
                                                        hide-details
                                                        color="#3E7662"
                                                        label="Procedure Changes"
                                                ></v-checkbox>
                                            </v-flex>
                                        </v-layout>
                                        <!-- row 3 -->
                                        <v-layout>
                                            <v-flex :class="!form.editorial ? '' : 'color-label-checkbox'">
                                                <v-checkbox
                                                        :disabled="!form.hasProtocolModify"
                                                        v-model="form.editorial"
                                                        hide-details
                                                        color="#3E7662"
                                                        label="Editorial / Administrative Changes"
                                                ></v-checkbox>
                                            </v-flex>
                                        </v-layout>
                                        <!-- row 3 -->
                                        <v-layout>
                                            <v-flex shrink :class="!form.hasOtherChange ? '' : 'color-label-checkbox'">
                                                <v-checkbox
                                                        :disabled="!form.hasProtocolModify"
                                                        hide-details
                                                        color="#3E7662"
                                                        v-model="form.hasOtherChange"
                                                        label="Other changes, please specify"
                                                        @change="otherChangeCheckbox()"
                                                ></v-checkbox>
                                            </v-flex>
                                            <v-flex ml-4 pt-1>
                                                <textfield-form-append
                                                        :disabled="!form.hasOtherChange"
                                                        :model="form.otherChange"
                                                        @update-data="updateData('otherChange', $event)"
                                                ></textfield-form-append>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <!-- Group 4-->
                                <v-layout px-12 mt-8>
                                    <!-- row 1-->
                                    <v-flex xs6 :class="!form.hasInvestigator ? '' : 'color-label-checkbox'" style="font-weight: bold;font-size: 18px" d-flex justify-start>
                                        <v-checkbox
                                                v-model="form.hasInvestigator"
                                                hide-details
                                                color="#3E7662"
                                                label="Investigator Brochure"
                                                @change="clearCheckbox('hasInvestigator')"
                                        ></v-checkbox>
                                    </v-flex>
                                    <v-flex xs6 d-flex justify-start>
                                        <v-layout pt-3>
                                            <v-flex xs6>
                                                <textfield-form-append
                                                        :disabled="!form.hasInvestigator"
                                                        :model="form.investigatorVersion"
                                                        css="color: #3E7662;font-weight: bold"
                                                        hide-detail
                                                        label="Version"
                                                        @update-data="updateData('investigatorVersion', $event)"
                                                ></textfield-form-append>
                                            </v-flex>
                                            <v-flex xs6>
                                                <DateInputFormAppend
                                                        :disabled="!form.hasInvestigator"
                                                        :model="investigatorDate"
                                                        style="color: #3E7662;"
                                                        label="Date"
                                                        @update-data="updateDate('investigatorDate', $event)"
                                                ></DateInputFormAppend>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <!-- row 2-->
                                <v-layout px-12>
                                    <v-flex xs6 :class="!form.hasNewInformation ? '' : 'color-label-checkbox'" style="font-weight: bold;font-size: 18px" d-flex justify-start>
                                        <v-checkbox
                                                v-model="form.hasNewInformation"
                                                hide-details
                                                color="#3E7662"
                                                label="New Information Provided to Subjects"
                                        ></v-checkbox>
                                    </v-flex>
                                </v-layout>
                                <!-- row 3-->
                                <v-layout px-12>
                                    <v-flex xs6 :class="!form.hasAdvertisement ? '' : 'color-label-checkbox'" style="font-weight: bold;font-size: 18px" d-flex justify-start>
                                        <v-checkbox
                                                v-model="form.hasAdvertisement"
                                                hide-details
                                                color="#3E7662"
                                                label="Advertisement (s) / Recruitment Letter (s)"
                                        ></v-checkbox>
                                    </v-flex>
                                </v-layout>
                                <!-- row 4-->
                                <v-layout px-12 mb-6>
                                    <v-flex shrink :class="!form.hasChangeInTitle ? '' : 'color-label-checkbox'" style="font-weight: bold;font-size: 18px" d-flex justify-start>
                                        <v-checkbox
                                                v-model="form.hasChangeInTitle"
                                                hide-details
                                                color="#3E7662"
                                                label="Change in Title :"
                                                @change="changeTitleCheckbox"
                                        ></v-checkbox>
                                    </v-flex>
                                    <v-flex pt-5 ml-3 shrink style="font-weight: bold;font-size: 16px;color: #3E7662">
                                        <span>(Attach revised consent form with new title)</span>
                                    </v-flex>
                                </v-layout>
                                <!-- Title form area -->
                                <v-layout mt-8 mb-4 style="padding-left: 80px;">
                                    <v-flex d-flex justify-start>
                                        <span style="font-size: 24px;font-weight: bold" :style="[!form.hasChangeInTitle ? {'color':'gray'}:{'color':'#000'}]">
                                            New Title :
                                        </span>
                                    </v-flex>
                                </v-layout>
                                <v-layout px-12>
                                    <v-flex>
                                        <textarea-form
                                                :model="form.changeInTitle"
                                                :disabled="!form.hasChangeInTitle"
                                                :rows="10"
                                                :background-color="!form.hasChangeInTitle ? '#F9F9F9' : '#FBF6F3'"
                                                @update-data="updateData('changeInTitle', $event)"
                                        ></textarea-form>
                                    </v-flex>
                                </v-layout>
                                <!-- Group 5 -->
                                <v-layout px-12>
                                    <v-flex :class="!form.hasChangeInInvestigator ? '' : 'color-label-checkbox'" d-flex justify-start style="font-size: 18px;font-weight: bold">
                                        <v-checkbox
                                                v-model="form.hasChangeInInvestigator"
                                                hide-details
                                                color="#3E7662"
                                                label="Change in Investigators :"
                                                @change="clearCheckbox('hasChangeInInvestigator')"
                                        ></v-checkbox>
                                    </v-flex>
                                </v-layout>
                                <v-layout px-12 mt-2>
                                    <v-flex style="text-align: left;color: #544A44;">
                                        <span>
                                            (Attach revised consent form., Include CV, ethical training records,
                                            and letter from Sponsor acknowledging change, if applicable)
                                        </span>
                                    </v-flex>
                                </v-layout>
                                <!-- text field append form  -->
                                <v-layout px-12 mt-3>
                                    <v-flex mr-6>
                                        <textfield-form-append
                                                css="font-weight: bold"
                                                :disabled="!form.hasChangeInInvestigator"
                                                :model="form.changeInInvestigatorAdd"
                                                label="Add Name : "
                                                @update-data="updateData('changeInInvestigatorAdd', $event)"
                                        ></textfield-form-append>
                                    </v-flex>
                                    <v-flex>
                                        <textfield-form-append
                                                css="font-weight: bold"
                                                :disabled="!form.hasChangeInInvestigator"
                                                :model="form.changeInInvestigatorDelete"
                                                label="Delete Name : "
                                                @update-data="updateData('changeInInvestigatorDelete', $event)"
                                        ></textfield-form-append>
                                    </v-flex>
                                </v-layout>
                                <!-- Group 6 -->
                                <v-layout px-12 mt-6>
                                    <v-flex :class="!form.hasChangeInSponsor ? '' : 'color-label-checkbox'" d-flex justify-start style="font-size: 18px;font-weight: bold">
                                        <v-checkbox
                                                v-model="form.hasChangeInSponsor"
                                                hide-details
                                                color="#3E7662"
                                                label="Change in Sponsor(s) :"
                                                @change="clearCheckbox('hasChangeInSponsor')"
                                        ></v-checkbox>
                                    </v-flex>
                                </v-layout>
                                <!-- text field append form  -->
                                <v-layout px-12 mt-3>
                                    <v-flex mr-6>
                                        <textfield-form-append
                                                :disabled="!form.hasChangeInSponsor"
                                                css="font-weight: bold"
                                                :model="form.changeInSponsorAdd"
                                                label="Add Sponsor Name : "
                                                @update-data="updateData('changeInSponsorAdd', $event)"
                                        ></textfield-form-append>
                                    </v-flex>
                                    <v-flex>
                                        <textfield-form-append
                                                :disabled="!form.hasChangeInSponsor"
                                                css="font-weight: bold"
                                                :model="form.changeInSponsorDelete"
                                                label="Delete Sponsor Name : "
                                                @update-data="updateData('changeInSponsorDelete', $event)"
                                        ></textfield-form-append>
                                    </v-flex>
                                </v-layout>
                                <!-- Group 7 -->
                                <v-layout mt-12 px-12>
                                    <v-flex>
                                        <v-layout>
                                            <v-flex xs6 pl-3 mr-6>
                                                <textfield-form-append
                                                        :model="form.signature"
                                                        hide-detail
                                                        icon="edit"
                                                        @update-data="updateData('signature', $event)"
                                                ></textfield-form-append>
                                            </v-flex>
                                            <v-flex xs3>
                                                <DateInputForm
                                                        :model="date"
                                                        label="Date"
                                                        @update-data="updateDate('date', $event)"
                                                ></DateInputForm>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout px-12 style="margin-top: -20px;font-weight: bold;">
                                            <v-flex xs6>
                                                <span>Signature of Principal Investigator</span>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-layout mt-12>
                                    <v-flex style="font-weight: bold" d-flex justify-start>
                                        <span>สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย พบ.</span>
                                    </v-flex>
                                    <v-flex style="font-weight: bold" d-flex justify-end>
                                        <span>หน้า 1 จาก 1 หน้า</span>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>

                        <!-- Blog 4 -->
                        <v-layout mt-3 style="background-color: #3E7662;">
                            <v-flex my-8 ml-8 style="text-align: left;font-weight: bold;font-size: 28px;color: white" @click="setData">
                                <div>แบบรายงานการแก้ไขเพิ่มเติมโครงร่างการวิจัย</div>
                                <div style="font-size: 18px;">Amendment Form</div>
                            </v-flex>
                        </v-layout>
                        <v-card class="mb-12 px-12">
                            <v-layout py-12>
                                <v-flex>
                                    <!-- row 1 -->
                                    <v-layout justify-center>
                                        <v-flex xs2 mr-4 pt-2 style="text-align: right;font-weight: bold;">
                                            <span>ชื่อโครงการวิจัย</span>
                                        </v-flex>
                                        <v-flex xs6>
                                            <textarea-form
                                                    :model="form.researchName2"
                                                    @update-data="updateData('researchName2', $event)"
                                            ></textarea-form>
                                        </v-flex>
                                    </v-layout>
                                    <!-- row 2 -->
                                    <v-layout justify-center>
                                        <v-flex xs2 mr-4 pt-2 style="text-align: right;font-weight: bold;">
                                            <span>ผู้วิจัย</span>
                                        </v-flex>
                                        <v-flex xs6>
                                            <textfield-form
                                                    :model="form.researcher"
                                                    @update-data="updateData('researcher', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>
                                    <!-- row 3 -->
                                    <v-layout justify-center>
                                        <v-flex xs2 mr-4 pt-2 style="text-align: right;font-weight: bold;">
                                            <span>เบอร์โทรศัพท์</span>
                                        </v-flex>
                                        <v-flex xs6>
                                            <textfield-form
                                                    :model="form.phoneNumber"
                                                    @update-data="updateData('phoneNumber', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>
                                    <!-- row 4 -->
                                    <v-layout justify-center>
                                        <v-flex xs2 mr-4 pt-2 style="text-align: right;font-weight: bold;">
                                            <span>สังกัด</span>
                                        </v-flex>
                                        <v-flex xs6>
                                            <textfield-form
                                                    :model="form.affiliation"
                                                    @update-data="updateData('affiliation', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-card>

                        <!-- Blog 5 -->
                        <v-layout pb-12>
                            <v-flex>
                                <!-- Table 1 -->
                                <v-layout py-4 style="background-color: #3E7662;">
                                    <v-flex>
                                        <span style="color: white;font-size: 24px">โครงร่างการวิจัยเดิม</span>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex>
                                        <v-divider style="background-color: #544A44;border-width: 2px"></v-divider>
                                    </v-flex>
                                </v-layout>
                                <v-layout px-4 py-4 style="background-color: #fff;">
                                    <v-flex shrink mr-2 d-flex justify-start align-center>
                                        <span>Version :</span>
                                    </v-flex>
                                    <v-flex xs1 mr-4 d-flex justify-start align-center>
                                        <TextfieldForm
                                                :model="edit.version"
                                                @update-data="tableUpdateData('version', $event)"
                                                hide-detail
                                        />
                                    </v-flex>
                                    <v-flex mr-2 shrink d-flex justify-start align-center>
                                        <span>หน้า/บรรทัด :</span>
                                    </v-flex>
                                    <v-flex mr-4 d-flex justify-start align-center>
                                        <TextfieldForm
                                                :model="edit.pageAndLine"
                                                @update-data="tableUpdateData('pageAndLine', $event)"
                                                hide-detail
                                        />
                                    </v-flex>
                                    <v-flex mr-2 shrink d-flex justify-start align-center>
                                        <span>ข้อมูล/ข้อเสนอแนะ :</span>
                                    </v-flex>
                                    <v-flex d-flex justify-start align-center>
                                        <TextfieldForm
                                                :model="edit.suggestion"
                                                @update-data="tableUpdateData('suggestion', $event)"
                                                hide-detail
                                        />
                                    </v-flex>
                                    <v-flex>
                                        <v-btn color="#3E7662" dark @click="add">
                                            <span>เพิ่มข้อมูล</span>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex>
                                        <v-divider style="background-color: #544A44;border-width: 2px"></v-divider>
                                    </v-flex>
                                </v-layout>

                                <!-- Table -->
                                <v-layout>
                                    <v-flex class="table">
                                        <v-data-table
                                                :headers="researchAllHeaders"
                                                :items="itemResearchAll"
                                                hide-default-footer
                                        >
                                            <template v-slot:item.delete="{item}">
                                                <v-icon color="#FF0000" @click="deleteRow(item)" style="cursor: pointer;">delete</v-icon>
                                            </template>
                                        </v-data-table>
                                    </v-flex>
                                </v-layout>

                                <v-layout>
                                    <v-flex>
                                        <v-divider style="background-color: #544A44;border-width: 2px"></v-divider>
                                    </v-flex>
                                </v-layout>

                            </v-flex>
                        </v-layout>

                        <!-- Blog 6 -->
                        <v-card>

                        </v-card>
                        <v-layout pb-12>
                            <v-flex>
                                <!-- Table 2 -->
                                <v-layout py-4 style="background-color: #3E7662;">
                                    <v-flex>
                                        <span style="color: white;font-size: 24px">การแก้ไขเพิ่มเติม</span>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex>
                                        <v-divider style="background-color: #544A44;border-width: 2px"></v-divider>
                                    </v-flex>
                                </v-layout>
                                <v-layout px-4 py-4 style="background-color: #fff;">
                                    <v-flex shrink mr-2 d-flex justify-start align-center>
                                        <span>Version :</span>
                                    </v-flex>
                                    <v-flex xs1 mr-4 d-flex justify-start align-center>
                                        <TextfieldForm
                                                :model="information.version"
                                                @update-data="tableEditUpdateData('version', $event)"
                                                hide-detail
                                        />
                                    </v-flex>
                                    <v-flex mr-2 shrink d-flex justify-start align-center>
                                        <span>หน้า/บรรทัด :</span>
                                    </v-flex>
                                    <v-flex mr-4 d-flex justify-start align-center>
                                        <TextfieldForm
                                                :model="information.pageAndLine"
                                                @update-data="tableEditUpdateData('pageAndLine', $event)"
                                                hide-detail
                                        />
                                    </v-flex>
                                    <v-flex mr-2 shrink d-flex justify-start align-center>
                                        <span>ข้อมูล/ข้อเสนอแนะ :</span>
                                    </v-flex>
                                    <v-flex d-flex justify-start align-center>
                                        <TextfieldForm
                                                :model="information.suggestion"
                                                @update-data="tableEditUpdateData('suggestion', $event)"
                                                hide-detail
                                        />
                                    </v-flex>
                                    <v-flex>
                                        <v-btn color="#3E7662" dark @click="addTableEdit">
                                            <span>เพิ่มข้อมูล</span>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex>
                                        <v-divider style="background-color: #544A44;border-width: 2px"></v-divider>
                                    </v-flex>
                                </v-layout>

                                <!-- Table -->
                                <v-layout>
                                    <v-flex class="table">
                                        <v-data-table
                                                :headers="researchAllHeaders"
                                                :items="itemTableEdit"
                                                hide-default-footer
                                        >
                                            <template v-slot:item.delete="{item}">
                                                <v-icon color="#FF0000" @click="deleteRowTableEdit(item)" style="cursor: pointer;">delete</v-icon>
                                            </template>
                                        </v-data-table>
                                    </v-flex>
                                </v-layout>

                                <v-layout>
                                    <v-flex>
                                        <v-divider style="background-color: #544A44;border-width: 2px"></v-divider>
                                    </v-flex>
                                </v-layout>

                            </v-flex>
                        </v-layout>

                        <!-- Blog 7 -->
                        <v-layout pt-12 pb-8 mb-8 style="background-color: white;padding-left: 60px;padding-right: 70px;">
                            <v-flex>
                                <v-layout justify-space-between>
                                    <v-flex xs5 pl-3 mr-6>
                                        <textfield-form-append
                                                :model="form.researcherSignature"
                                                css="font-weight: bold;"
                                                label="ผู้วิจัย"
                                                hide-detail
                                                @update-data="updateData('researcherSignature', $event)"
                                        ></textfield-form-append>
                                    </v-flex>
                                    <v-flex xs5>
                                        <DateInputForm
                                                :model="reportDate"
                                                label="วันที่รายงาน"
                                                @update-data="updateDate('reportDate', $event)"
                                        ></DateInputForm>
                                    </v-flex>
                                </v-layout>
                                <v-layout mt-8>
                                    <v-flex style="font-weight: bold" d-flex justify-start>
                                        <span>สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย พบ.</span>
                                    </v-flex>
                                    <v-flex style="font-weight: bold" d-flex justify-end>
                                        <span>หน้า 1 จาก 1 หน้า</span>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>

                        <!-- Button Save -->
                        <v-layout>
                            <v-flex mb-12 style="text-align: right;">
                                <v-layout>
                                    <v-flex>
                                        <v-btn style="color: #3E7662" class="mx-4" depressed  color="#ffffff" @click="viewData">ย้อนกลับ</v-btn>
                                        <v-btn depressed  dark color="#3E7662" @click="save">
                                            <v-icon class="mr-3">add</v-icon>
                                            <span>บันทึกข้อมูล</span>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <loading
                        color="#527281"
                        :active.sync="isLoading"
                        :can-cancel="false"
                        :is-full-pageAndLine="fullpageAndLine"
                ></loading>
            </v-flex>
        </v-layout>
    </v-content>
</template>

<script>
    import TextfieldForm from "../../components/input/TextfieldForm";
    import DateInputForm from "../../components/input/DateInputForm";
    import TextareaForm from "../../components/input/TextareaForm";
    import Swal from 'sweetalert2';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import TextfieldFormAppend from "../../components/input/TextfieldFormAppend";
    import DateInputFormAppend from "../../components/input/DateInputFormAppend";
    import { mapState } from "vuex";

    export default {
        name: "FormRF06",
        components: {
            TextfieldForm,
            DateInputForm,
            TextareaForm,
            Loading,
            TextfieldFormAppend,
            DateInputFormAppend,
            // editAdd,
        },
        computed: {
            ...mapState({
                researchID: state => state.formRF.researchID
            }),
            ...mapState({
                user: state => state.Auth.user
            })
        },
        data: () => ({
            isLoading: false,
            fullpageAndLine: true,
            selected: [],
            dialog: false,
            form: {
                // blog 1
                researchCode: '',
                firstName: '',
                lastName: '',
                researchName: '',
                // blog 2
                hasScreening: '1',
                screening: '',
                hasAdjustMethod: '1',
                adjustMethod: '',
                hasAddOperate: '1',
                addOperate: '',
                hasExpandTime: '1',
                expandTime: '',
                hasAdjustOtherMethod: '1',
                adjustOtherMethod: '',
                // blog 3
                hasInformationSheet: false,
                informationSheetVersion: '',
                informationSheetDate: '',
                hasProtocolModify: false,
                protocolModifyVersion: '',
                protocolModifyDate: '',
                inclusion: false,
                procedureChange: false,
                editorial: false,
                hasOtherChange: false,
                otherChange: '',
                hasInvestigator: false,
                investigatorVersion: '',
                investigatorDate: '',
                hasNewInformation: false,
                hasAdvertisement: false,
                hasChangeInTitle: false,
                changeInTitle: '',
                hasChangeInInvestigator: false,
                changeInInvestigatorAdd: '',
                changeInInvestigatorDelete: '',
                hasChangeInSponsor: false,
                changeInSponsorAdd: '',
                changeInSponsorDelete: '',
                signature: '',
                date: '',
                // blog 4
                researchName2:'',
                researcher:'',
                phoneNumber:'',
                affiliation:'',
                // blog 7
                researcherSignature: '',
                reportDate: '',
            },
            researchAllHeaders: [
                {text: 'Version', value: 'version', align: "center"},
                { text: 'หน้า / บรรทัด', value: 'pageAndLine', align: "center" },
                { text: 'ข้อมูลเดิม / ข้อเสนอแนะ', value: 'suggestion', align: "center" },
                { text: 'ลบ', value: 'delete', align: "center" },
            ],
            itemResearchAll: [],
            itemTableEdit: [],
            edit: {
                version: '',
                pageAndLine: '',
                suggestion: '',
            },
            information: {
                version: '',
                pageAndLine: '',
                suggestion: '',
            },
            userID: '',

            date: '',
            reportDate: '',
            informationSheetDate: '',
            protocolModifyDate: '',
            investigatorDate: '',
        }),
        created() {
            // Check Permission Access
            //if (this.user.currentRole !== 3) {
             //   this.$router.go(-1);
            //}

            // console.log('userID', this.$route.query.userID)
            this.userID = this.$route.query.userID;
            this.getRF12(this.$route.query.rfID);
        },
        methods:{
            viewData() {
                this.$router.push({name: 'ViewDataPostApprove', query: { id: this.userID }})
            },
            updateData(name, val) {
                this.form[name] = val;
            },
            updateDate(name,val) {
                if (name === "date") {
                    this.form.date = val.date;
                    this.date = this.changeDate(val.date);
                }
                if (name === "reportDate") {
                    this.form.reportDate = val.date;
                    this.reportDate = this.changeDate(val.date);
                }
                if (name === "informationSheetDate") {
                    this.form.informationSheetDate = val.date;
                    this.informationSheetDate = this.changeDate(val.date);
                }
                if (name === "protocolModifyDate") {
                    this.form.protocolModifyDate = val.date;
                    this.protocolModifyDate = this.changeDate(val.date);
                }
                if (name === "investigatorDate") {
                    this.form.investigatorDate = val.date;
                    this.investigatorDate = this.changeDate(val.date);
                }
            },
            changeDate(val) {
                //change date start
                let sub_year = val.substring(0,4);
                let sub_month = val.substring(5,7);
                let sub_day = val.substring(8,10);
                sub_year = parseInt(sub_year)+543;
                let changeDate = sub_day + '/' + sub_month + '/' + sub_year;
                return changeDate;
            },
            tableUpdateData(name, val) {
                this.edit[name] = val;
            },
            tableEditUpdateData(name, val) {
                this.information[name] = val;
            },
            getRF12(id) {
                this.isLoading = true;
                this.$store.dispatch("FormRF/getRF12", id).then(res => {
                    // console.log('RF12 : ' ,res);
                    if (res !== "don't have research amendment yet") {
                        this.form.researchCode = res.researchCode;
                        this.form.firstName = res.firstName;
                        this.form.lastName = res.lastName;
                        this.form.researchName = res.researchName;
                        this.form.hasScreening = res.hasScreening.toString();
                        this.form.screening = res.screening;
                        this.form.hasAdjustMethod = res.hasAdjustMethod.toString();
                        this.form.adjustMethod = res.adjustMethod;
                        this.form.hasAddOperate = res.hasAddOperate.toString();
                        this.form.addOperate = res.addOperate;
                        this.form.hasExpandTime = res.hasExpandTime.toString();
                        this.form.expandTime = res.expandTime;
                        this.form.hasAdjustOtherMethod = res.hasAdjustOtherMethod.toString();
                        this.form.adjustOtherMethod = res.adjustOtherMethod;
                        this.form.hasInformationSheet = res.hasInformationSheet.toString();
                        this.form.informationSheetVersion = res.informationSheetVersion;
                        this.form.informationSheetDate = res.informationSheetDate;
                        this.informationSheetDate = res.informationSheetDate ? this.changeDate(res.informationSheetDate) : '';
                        this.form.hasProtocolModify = res.hasProtocolModify.toString();
                        this.form.protocolModifyVersion = res.protocolModifyVersion;
                        this.form.protocolModifyDate = res.protocolModifyDate;
                        this.protocolModifyDate = res.protocolModifyDate ? this.changeDate(res.protocolModifyDate) : '';
                        this.form.inclusion = res.inclusion.toString();
                        this.form.procedureChange = res.procedureChange.toString();
                        this.form.editorial = res.editorial.toString();
                        this.form.hasOtherChange = res.hasOtherChange.toString();
                        this.form.otherChange = res.otherChange;
                        this.form.hasInvestigator = res.hasInvestigator.toString();
                        this.form.investigatorVersion = res.investigatorVersion;
                        this.form.investigatorDate = res.investigatorDate;
                        this.investigatorDate = res.investigatorDate ? this.changeDate(res.investigatorDate) : '';
                        this.form.hasNewInformation = res.hasNewInformation.toString();
                        this.form.hasAdvertisement = res.hasAdvertisement.toString();
                        this.form.hasChangeInTitle = res.hasChangeInTitle.toString();
                        this.form.changeInTitle = res.changeInTitle;
                        this.form.hasChangeInInvestigator = res.hasChangeInInvestigator.toString();
                        this.form.changeInInvestigatorAdd = res.changeInInvestigatorAdd;
                        this.form.changeInInvestigatorDelete = res.changeInInvestigatorDelete;
                        this.form.hasChangeInSponsor = res.hasChangeInSponsor.toString();
                        this.form.changeInSponsorAdd = res.changeInSponsorAdd;
                        this.form.changeInSponsorDelete = res.changeInSponsorDelete;
                        this.form.signature = res.signature;
                        this.form.date = res.date;
                        this.date = res.date ? this.changeDate(res.date) : '';
                        this.form.researchName2 =res.researchName2;
                        this.form.researcher =res.researcher;
                        this.form.phoneNumber =res.phoneNumber;
                        this.form.affiliation =res.affiliation;
                        this.form.researcherSignature = res.researcherSignature;
                        this.form.reportDate = res.reportDate;
                        this.reportDate = res.reportDate ? this.changeDate(res.reportDate) : '';
                        if (res.research_amendment_edit) {
                            let researchEdit = res.research_amendment_edit;
                            res.research_amendment_edit.forEach(data => {
                                this.itemTableEdit.push({
                                    version: data.version,
                                    pageAndLine: data.pageAndLine,
                                    suggestion: data.suggestion,
                                });
                            })
                        }
                        if (res.research_amendment_information) {
                            // console.log('res.research_amendment_information', res.research_amendment_information)
                            let researchInformation = res.research_amendment_edit;
                            res.research_amendment_information.forEach(data => {
                                this.itemResearchAll.push({
                                    version: data.version,
                                    pageAndLine: data.pageAndLine,
                                    suggestion: data.suggestion,
                                });
                            })
                        }
                        this.isLoading = false;
                    }
                    this.isLoading = false;
                })
            },
            save() {
                Swal.fire({
                    title: 'คุณต้องการบันทึกหรือไม่?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3E7662',
                    cancelButtonColor: 'rgb(189, 189, 189)',
                    confirmButtonText: 'ใช่ บันทึก',
                }).then((result) => {
                    if (result.value) {
                        this.isLoading = true;
                        this.form['researchID'] = this.$route.query.id;
                        this.form['edit'] = this.itemResearchAll;
                        this.form['information'] = this.itemTableEdit;
                        this.$store.dispatch("FormRF/saveRF12", this.form).then(res => {
                            Swal.fire({
                                position: 'center',
                                icon: 'success',
                                title: 'บันทึกสำเร็จ',
                                showConfirmButton: false,
                                timer: 1500
                            })
                            this.isLoading = false;
                            this.viewData();
                            // this.$router.push('/profile')
                        }).catch(e => {
                            this.isLoading = false;
                            if (e.response.data.errors) {
                                for (var k in e.response.data.errors) {
                                Swal.fire({
                                    title: "เกิดข้อผิดพลาด",
                                    text: e.response.data.errors[k][0],
                                    icon: "warning",
                                    confirmButtonColor: "#3E7662",
                                }).then(() => {
                                    this.$vuetify.goTo(`#${k}`);
                                });
                                }
                            }
                            // Swal.fire({
                            //     title: 'Save failed!',
                            //     text: 'บันทึกไม่สำเร็จ',
                            //     icon: 'warning',
                            // }).then(() => {
                            //     this.isLoading = false;
                            // })
                        })
                    }
                });
            },
            otherChangeCheckbox() {
                if (!this.form.hasOtherChange) {
                    this.form.otherChange = '';
                }
            },
            changeTitleCheckbox() {
                if (!this.form.hasChangeInTitle) {
                    this.form.changeInTitle = '';
                }
            },
            clearCheckbox(name) {
                if (name === 'hasInformationSheet') {
                    if (!this.form.hasInformationSheet) {
                        this.form.informationSheetDate = '';
                        this.form.informationSheetVersion = '';
                    }
                }
                if (name === 'hasProtocolModify') {
                    if (!this.form.hasInformationSheet) {
                        this.form.protocolModifyVersion = '';
                        this.form.protocolModifyDate = '';
                        this.form.inclusion = false;
                        this.form.procedureChange = false;
                        this.form.editorial = false;
                        this.form.hasOtherChange = false;
                        this.form.otherChange = '';
                    }
                }
                if (name === 'hasInvestigator') {
                    if (!this.form.hasInvestigator) {
                        this.form.investigatorVersion = '';
                        this.form.investigatorDate = '';
                    }
                }
                if (name === 'hasChangeInInvestigator') {
                    if (!this.form.hasChangeInInvestigator) {
                        this.form.changeInInvestigatorAdd = '';
                        this.form.changeInInvestigatorDelete = '';
                    }
                }
                if (name === 'hasChangeInSponsor') {
                    if (!this.form.hasChangeInSponsor) {
                        this.form.changeInSponsorAdd = '';
                        this.form.changeInSponsorDelete = '';
                    }
                }

            },
            clearRedio(name) {
                if (name === 'hasAddOperate') {
                    this.form.addOperate = '';
                    this.form.hasAddOperate = '1';
                }
                if (name === 'hasExpandTime') {
                    this.form.expandTime = '';
                    this.form.hasExpandTime = '1';
                }
                if (name === 'hasAdjustOtherMethod') {
                    this.form.adjustOtherMethod = '';
                    this.form.hasAdjustOtherMethod = '1';
                }
                if (name === 'hasAdjustMethod') {
                    this.form.adjustMethod = '';
                    this.form.hasAdjustMethod = '1';
                }
                if (name === 'hasScreening') {
                    this.form.screening = '';
                    this.form.hasScreening = '1';
                }

            },
            add() {
                if (this.edit.version && this.edit.pageAndLine && this.edit.suggestion) {
                    this.itemResearchAll.push({
                        index: new Date().valueOf(),
                        version: this.edit.version,
                        pageAndLine: this.edit.pageAndLine,
                        suggestion: this.edit.suggestion,
                    })
                } else {
                    Swal.fire({
                        title: 'กรุณากรอกข้อมูลให้ครบ',
                        icon: 'warning',
                        confirmButtonColor: '#3E7662'
                    })
                }

            },
            addTableEdit() {
                if (this.information.version && this.information.pageAndLine && this.information.suggestion) {
                    this.itemTableEdit.push({
                        index: new Date().valueOf(),
                        version: this.information.version,
                        pageAndLine: this.information.pageAndLine,
                        suggestion: this.information.suggestion,
                    })
                } else {
                    Swal.fire({
                        title: 'กรุณากรอกข้อมูลให้ครบ',
                        icon: 'warning',
                        confirmButtonColor: '#3E7662'
                    })
                }

            },
            deleteRow(val) {
                this.itemResearchAll = this.itemResearchAll.filter(item => item.index !== val.index)
            },
            deleteRowTableEdit(val) {
                this.itemTableEdit = this.itemTableEdit.filter(item => item.index !== val.index)
            },
            setData() {
                this.form.researchCode = 'Test';
                this.form.firstName = 'Test';
                this.form.lastName = 'Test';
                this.form.researchName = 'Test';
                this.form.hasScreening = '0';
                this.form.screening = 'Test';
                this.form.hasAdjustMethod = '0';
                this.form.adjustMethod = 'Test';
                this.form.hasAddOperate = '0';
                this.form.addOperate = 'Test';
                this.form.hasExpandTime = '0';
                this.form.expandTime = 'Test';
                this.form.hasAdjustOtherMethod = '0';
                this.form.adjustOtherMethod = 'Test';
                this.form.hasInformationSheet = '0';
                this.form.informationSheetVersion = 'Test';
                this.form.informationSheetDate = new Date().toISOString().substr(0, 10);
                this.form.hasProtocolModify = '0';
                this.form.protocolModifyVersion = 'Test';
                this.form.protocolModifyDate = new Date().toISOString().substr(0, 10);
                this.form.inclusion = '0';
                this.form.procedureChange = '0';
                this.form.editorial = '0';
                this.form.hasOtherChange = '0';
                this.form.otherChange = 'Test';
                this.form.hasInvestigator = '0';
                this.form.investigatorVersion = 'Test';
                this.form.investigatorDate = new Date().toISOString().substr(0, 10);
                this.form.hasNewInformation = '0';
                this.form.hasAdvertisement = '0';
                this.form.hasChangeInTitle = '0';
                this.form.changeInTitle = 'Test';
                this.form.hasChangeInInvestigator = '0';
                this.form.changeInInvestigatorAdd = 'Test';
                this.form.changeInInvestigatorDelete = 'Test';
                this.form.hasChangeInSponsor = '0';
                this.form.changeInSponsorAdd = 'Test';
                this.form.changeInSponsorDelete = 'Test';
                this.form.signature = 'Test';
                this.form.date = new Date().toISOString().substr(0, 10);
                this.form.researchName2 ='Test';
                this.form.researcher ='Test';
                this.form.phoneNumber ='Test';
                this.form.affiliation ='Test';
                this.form.researcherSignature = 'Test';
                this.form.reportDate = new Date().toISOString().substr(0, 10);
            }
        },
    }
</script>

<style lang="scss">
    label.v-label.theme--light {
        color: #544A44;
    }
    .color-label-checkbox {
        label.v-label.theme--light {
            color: #3E7662;
        }
    }

</style>
